export default __webpack_public_path__ + "static/media/phone.9019400e.svg";